import { TenantJob } from '~/tenants/common/TenantJob';
import { MpxOrderContext, MpxPerformableConfig } from '~/tenants/mpx/model/MpxOrder';

export default abstract class MpxJob<P extends MpxPerformableConfig> extends TenantJob<MpxOrderContext, P> {}
